import { useContext, useState,useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import styles from "./WareHouse.module.css";
import { TracingEventContext } from "../../../../contexts";

const cx = classNames.bind(styles);
const Camera = ({ name, status, check, camID, setCheck,isChange }) => {
  const {
    cameraCode,
    setCameraCode,
    setName,
    listCodeCamera,
    setListCodeCamera,
    isApply, setIsApply
  } = useContext(TracingEventContext);
  const [isCheck, setIsCheck] = useState(false);

  const handleChangeStatus = (e,code,name) => {
    setIsCheck(e);
    setIsApply(true)
    if(e){
      if(!listCodeCamera.some(item=>item.code === code)){
        setListCodeCamera([...listCodeCamera,{code:code,name:name}])
      }
    }
    else{
      const data = listCodeCamera.filter(item=>item.code!==code)
      setListCodeCamera(data)
    }
  };

  const handleGetPlayBack = (code, name, isCheck) => {
    // setCameraCode(code);
    // setName(name);
    handleChangeStatus(!isCheck,code,name);
    // setCheck(false);
  };
 useEffect(()=>{
    const some = listCodeCamera.some(item=> item.code === camID)
    setIsCheck(some)
  },[listCodeCamera])
  useEffect(() => {
    if (isChange) {
      setIsCheck(check);
    }
  }, [ check]);
  return (
    <div
      className={cx("item-cam", camID === cameraCode ? "active" : "")}
      onClick={(e) => handleGetPlayBack(camID, name, isCheck)}
    >
      <div className={cx("camera")}>
        <span className={cx(status, "hover")}>
          <div className={cx("tooltip")}>
            {status === "On" ? "Đang trực tuyến" : "Sẵn sàng"}
          </div>
        </span>
        <span className={cx("name")}>{name}</span>
        <input
          type="checkbox"
          id="check-camera"
          checked={isCheck}
          onChange={(e) => handleChangeStatus(e.target.checked,camID,name)}
        />
      </div>
    </div>
  );
};
Camera.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  check: PropTypes.bool.isRequired,
  camID: PropTypes.string.isRequired,
  prioritized: PropTypes.string.isRequired,
};
export default Camera;
